import { Button, Col, Dropdown, Menu, Row, Tag } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MoreOutlined } from "@ant-design/icons";
import { ROUTES } from "../../../constants";
import { getFormattedDateTime } from "../../../utils/commonUtils";
import { SERVICE_TYPE } from "../../../types/common";
import { DeleteIcon, EditIcon } from "../../../components";
import { useAppSelector } from "../../../redux/hooks";
import useDeleteImpactModal from "../../../hooks/useDeleteImpactModal";
import DeleteConfirmationModal from "../../testExecutionSuit/modals/DeleteConfirmationModal";
import { getDeleteImpact } from "../actions";

interface GeneratedTestcaseListVIewItemProps {
  requirement: any;
  deleteRequirement: (requirementId: string) => Promise<boolean>;
  editRequirement: Function;
}
const GeneratedTestCaseListViewItem = ({
  requirement,
  deleteRequirement,
  editRequirement,
}: GeneratedTestcaseListVIewItemProps) => {
  const accountId = useAppSelector(
    ({ userData }: any) => userData?.selectedAccount?.accountId,
  );
  const [isDeleting, setDeleting] = useState<boolean>(false);
  const navigate = useNavigate();
  const {
    isModalOpen,
    affectedSuites,
    isImpactLoading,
    openDeleteModal,
    closeDeleteModal,
  } = useDeleteImpactModal({
    accountId,
    fetchDeleteImpact: getDeleteImpact,
  });
  const viewResults = () =>
    navigate(
      `${ROUTES.TESTCASE_RESULT}/${requirement.moduleId}/${requirement.requirementId}`
    );

  const getServiceType = (serviceId: string = "") => {
    switch (serviceId) {
      case SERVICE_TYPE.AUTOMATION_SCRIPT_GENERATOR:
        return "Automation Script";
      case SERVICE_TYPE.TEST_CASE_GENERATOR:
        return "Testcase Generation";
      default:
        return "";
    }
  };

  const handleDelete = async () => {
    if (!requirement?.requirementId || isDeleting) {
      return;
    }

    setDeleting(true);
    const isDeleted = await deleteRequirement(requirement.requirementId);
    if (isDeleted) {
      closeDeleteModal();
    }
    setDeleting(false);
  };

  return (
    <div className="fp_test_exec_list_item">
      <Row justify="space-between" className="fp_list_item">
        <Col span={6} onClick={viewResults}>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <Col span={24}>
              <p className="fp_testcase_name">
                {requirement.requirement || requirement.requirementDescription}
              </p>
            </Col>
            {/* <Col span={6}>
            <Button className="fp_btn fp_btn-link">Edit</Button>
          </Col> */}
          </Row>
        </Col>
        <Col span={4} onClick={viewResults}>
          <Tag style={{ border: "none" }}>
            {getServiceType(requirement?.serviceId)}
          </Tag>
          <p />
        </Col>
        {/* TODO: Removed result section for demo version */}
        {/* <Col span={4}><p>{test.type}</p></Col> */}
        <Col span={6} onClick={viewResults}>
          <Row>
            <Col span={18}>
              <p>{getFormattedDateTime(requirement.createdAt)}</p>
            </Col>
          </Row>
        </Col>
        <Col span={4} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Row className="fp_test_exec_list_item_action">
            <Col>
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu className="fp-drop-down-menu">
                    <Menu.Item>
                      <Button
                        className="fp_btn fp_btn-link"
                        onClick={() => editRequirement(requirement)}
                        style={{ width: "100%", textAlign: "left" }}
                        icon={<EditIcon />}
                      >
                        Edit
                      </Button>
                    </Menu.Item>
                    <Menu.Item>
                      <Button
                        className="fp_btn fp_btn-link"
                        onClick={() =>
                          openDeleteModal({
                            requirementId: requirement.requirementId,
                          })
                        }
                        style={{ width: "100%", textAlign: "left" }}
                        icon={<DeleteIcon />}
                      >
                        Delete
                      </Button>
                    </Menu.Item>
                  </Menu>
                }
              >
                <p style={{ marginBottom: 0, cursor: "pointer" }}>
                  <MoreOutlined style={{ fontSize: "20px" }} />
                </p>
              </Dropdown>
            </Col>
          </Row>
        </Col>
      </Row>

      <DeleteConfirmationModal
        title="Are you sure you want to delete this requirement?"
        deleteButtonText="Delete Requirement"
        isModalOpen={isModalOpen}
        warningMessage="Deleting this item will remove scripts from one or more test execution suites."
        affectedSuites={affectedSuites}
        isImpactLoading={isImpactLoading}
        handleCancel={closeDeleteModal}
        handleDelete={handleDelete}
        isLoading={isDeleting}
      />
    </div>
  );
};

export default GeneratedTestCaseListViewItem;
